<template>
  <div class="versionOld">
    <div class="lastTitle">
       <span>旧版模板消息(通知)设置</span>
    </div>
    <div>
      <SimpleTable
        :headerCellClassName='headerCellClassName'
        :cellClassName='cellClassName'
        :tableDataTitle='oldTemplateTableDataTitle'
       :tableDataP='oldTemplateTableData' border
       :tableStyleName='"publicNumTable"'
       @cellClick='cellClick'
       ></SimpleTable>
    </div>

    <!-- 修改弹窗 -->
    <el-dialog
      :title="oldTemplateConfigBoxTitle"
      :visible.sync="oldTemplateConfigVisible"
      width="24%"
      custom-class="oldTemplateConfigBox"
    >
      <div class="oldTemplateConfigBoxBody" style="border:1px solid #ddd">
        <el-input v-model='templateCode'></el-input>
        <div class="tipConfig">{{tipConfig}}</div>
      </div>
      <div class="oldTemplateConfigBoxFooter">
        <el-button type="default" @click="oldTemplateConfigVisible=false">关闭</el-button>
        <el-button type="primary" @click="saveBtn()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import SimpleTable from '@/components/template/simpleTable'
  import api from '@/config/api';

  export default {
  data(){
    let headerCellClassName=({row,rowIndex})=>{
      return 'publicNumTemplateHeader';
    }
    let cellClassName=({row, column, rowIndex, columnIndex})=>{
      if(columnIndex===2){
        return 'operator'
      }
      return 'publicNumTemplateCell';
    }
    return{
      id:null,
      oldTemplateConfigBoxTitle:'会员卡激活设置',
      tipConfig:'',
      currentIndex:0,
      oldTemplateConfigVisible:false,
      headerCellClassName,
      cellClassName,
      templateCode:'',
      oldTemplateTableDataTitle:[],
      oldTemplateTableData:[]
    }
  },
  created(){
    this.oldTemplateTableDataTitle=[
      {
        prop:'templateType',
        label:'类型',
      },{
        prop:'templateCode',
        label:'模板消息编码'
      },{
        prop:'operator',
        label:'操作'
      }
    ];
    this.oldTemplateTableData=[
      {
        index:0,
        templateType:'会员卡激活',
        templateCode:'',
        operator:'修改',
        remind:`请在“微信公众平台”选择行业为：“IT科技 - 互联网|电子商务”，添加标题为：“会员卡办理提醒”，编号为：“OPENTM400566501”的模板。`

      },
      {
        index:1,
        templateType:'会员卡充值',
        templateCode:'',
        operator:'修改',
        remind:`请在“微信公众平台”选择行业为：“IT科技 - 互联网|电子商务”，添加标题为：”充值通知“，编号为：“TM00006”的模板。`
      },
      {
        index:2,
        templateType:'会员消费',
        templateCode:'',
        operator:'修改',
        remind:`请在“微信公众平台”选择行业为：“IT科技 - 互联网|电子商务”，添加标题为：“消费通知”，编号为：“TM00005”的模板。`
      },
      {
        index:3,
        templateType:'优惠券发放',
        templateCode:'',
        operator:'修改',
        remind:`请在“微信公众平台”选择行业为：“IT科技 - 互联网|电子商务”，添加标题为：”业务生效通知“，编号为：“OPENTM204855081”的模板`
      },
    ]
    let url=api.system.oldSysMarkList;
    this.$axios.fetchPost(url).then((res)=>{
      if(res.code===200){
        for(let i=0;i<res.data.length;i++){
          this.id=res.data[i].id;
          this.oldTemplateTableData[0].templateCode=res.data[i].vipMark;
          this.oldTemplateTableData[1].templateCode=res.data[i].rechargeMark;
          this.oldTemplateTableData[2].templateCode=res.data[i].payMark;
          this.oldTemplateTableData[3].templateCode=res.data[i].vipaddMark;
        }
      }else{
        this.$message.error('获取模板数据失败')
      }
    })
  },
  methods:{
    saveBtn(){
      this.oldTemplateTableData[this.currentIndex].templateCode=this.templateCode;
      let url=api.system.oldSysMark;
      let data={
        id:this.id,
        vipMark:this.oldTemplateTableData[0].templateCode,
        rechargeMark:this.oldTemplateTableData[1].templateCode,
        payMark:this.oldTemplateTableData[2].templateCode,
        vipaddMark:this.oldTemplateTableData[3].templateCode
      }
      const loading=this.$loading();
      console.log('要传的值',data)
      this.$axios.fetchPost(url,data).then((res)=>{
        if(res.code===200){
          loading.close();
          this.oldTemplateConfigVisible=false;
          this.$notify({
            type: "success",
            title: '设置操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({
          //   message:'设置成功',
          //   type:'success'
          // })
        }else{
          this.$notify({
            type: "error",
            title: '设置操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error('设置失败！');
        }
      })
    },
    cellClick(row,columnName){
      console.log('row',row,columnName)
      this.currentIndex=row.index;
      switch (columnName) {
        case 'operator':
          console.log('操作列点击')
          this.oldTemplateConfigVisible=true;
          //模态框模板Code
          this.templateCode=row.templateCode,
          this.oldTemplateConfigBoxTitle=row.templateType;

          this.tipConfig=row.remind;
          break;

        default:
          break;
      }
    }
  },
  components:{
    SimpleTable,
  }
}
</script>

<style scoped>
.lastTitle{
  height: 42px;
  padding: 0px 15px;
  border-bottom: 1px solid #f6f6f6;
  line-height: 42px;
}
.oldTemplateConfigBoxBody .tipConfig{
    width: calc(100% - 60px);
    margin: 0px 30px 30px 30px;
}

.oldTemplateConfigBoxFooter{
  text-align: right;
  margin-top:30px;
}

.el-select, .el-input, .el-input-number{
    width: calc(100% - 60px);
    margin: 30px 30px 0px 30px;
}
</style>



// WEBPACK FOOTER //
// src/page/system/wechat/VersionOld.vue